import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { kaiTypographyWeb } from '../../../typography';
import { REVIEW_COLORS } from '../reviewFlowTokens';
import {
  resolveStyleOverride,
  type StyleOverride,
} from '../styleOverrides';

export interface MetaTextProps extends HTMLAttributes<HTMLSpanElement> {
  styleOverride?: StyleOverride;
}

export const MetaText = forwardRef<HTMLSpanElement, MetaTextProps>(
  ({ styleOverride: metaCss, style, ...props }, ref) => {
    return (
      <span
        ref={ref}
        style={{
          ...kaiTypographyWeb.xxSmall,
          letterSpacing: '0.04em',
          color: REVIEW_COLORS.textSoft,
          ...style,
          ...resolveStyleOverride(metaCss),
        }}
        {...props}
      />
    );
  },
);

MetaText.displayName = 'MetaText';
